import { StringIdentifierSerializer } from './string-identifier-serializer';

export function stringIdentifierStringSerializer<ExtendedType extends string = string>(
    extraConversion?: (parsed: string) => ExtendedType,
): StringIdentifierSerializer<ExtendedType> {
    return {
        deserialize(stringVal) {
            if (extraConversion) {
                return extraConversion(stringVal);
            }
            return stringVal as ExtendedType;
        },
        serialize(val) {
            return val.toString();
        },
    };
}
